import React, { useEffect, useState } from "react";
import { Button } from "antd";
import "./EmployeeDetail.scss";
import EditDetailsModal from "./EditDetailsModal";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getEmployeeDetails } from "../../../assets/api/othres";

const EmployeeDetail = () => {
  const [editOpen, setEditOpen] = useState(false);
  const { token } = useSelector((state) => state.auth);
  const [employeeData, setEmployeeData] = useState(null);
  const { id } = useParams();

  const fetchEmployeeDetails = async () => {
    try {
      const res = await getEmployeeDetails(id, token);
      if (res.status === 200) {
        setEmployeeData(res?.data?.data);
      }
    } catch (error) {

    }
  }
  useEffect(() => {
    fetchEmployeeDetails();
  }, [])

  return (
    <div className="employeeDetailsCard">
      <h3>Employee Details</h3>
      <div className="employeeDetailsHeader">
        <div className="avatarInfo">
          <div className="avatar">
            {/* Optional image if available */}
            <img
              src={"/default-avatar.png"}
              alt="employeePF"
            />
          </div>
          <div className="userInfo">
            <h3>{employeeData?.name}</h3>
            <p className="userId">#{employeeData?.email}</p>
          </div>
        </div>
        <Button className="editBtn" onClick={() => setEditOpen(true)}>
          Edit Details
        </Button>
      </div>

      <div className="employeeDetailsTable">
        <div className="detailRow">
          <div className="detailItem">
            <span className="label">Role</span>
            <span className="value">{employeeData?.role}</span>
          </div>
          <div className="detailItem">
            <span className="label">Email</span>
            <span className="value">{employeeData?.email}</span>
          </div>
          <div className="detailItem">
            <span className="label">Date Of Joining</span>
            <span className="value">
              {new Date(employeeData?.date_of_joining).toLocaleDateString()}
            </span>
          </div>
          <div className="detailItem">
            <span className="label">Phone No.</span>
            <span className="value">{employeeData?.phone}</span>
          </div>
          {
            (employeeData?.role !== 'Supervisor' && employeeData?.role !==
              "Team Lead") && (
              <div className="detailItem">
                <span className="label">Team Lead</span>
                <span className="value">{employeeData?.team_lead || "—"}</span>
              </div>
            )
          }
          {
            employeeData?.role !== 'Supervisor' && (
              <div className="detailItem">
                <span className="label">Supervisor</span>
                <span className="value">{employeeData?.supervisor?.join(', ') || "—"}</span>
              </div>
            )
          }

          <div className="detailItem">
            <span className="label">City</span>
            <span className="value">{employeeData?.city || "—"}</span>
          </div>
          <div className="detailItem">
            <span className="label">Pin code</span>
            <span className="value">{employeeData?.pincode || "—"}</span>
          </div>
        </div>
      </div>

      <EditDetailsModal
        open={editOpen}
        onClose={() => setEditOpen(false)}
        employee={employeeData}
      />
    </div>
  );
};

export default EmployeeDetail;
